<template>
  <div>
	<!-- Fonts -->
	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet">
	<!-- Fontawesome -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css">

    <loader-screen v-if="showLoader && !isTvDisplayRoute"></loader-screen>
    <router-view></router-view>
  </div>
</template>

<style>
body {
  background-color: #e4e5e6 !important;
}
</style>

<script>
const TV_DISPLAY_ROUTE_NAMES = [
  'ScoreboardLoopPlayer',
  'ScoreboardBoardPreview',
  'ScoreboardBoardRender',
];

export default {
  name: 'app',
  data: function() {
    return {
      showLoader: false
    }
  },
  computed: {
    // Wall TVs and capture windows already have the previous board on screen.
    // The CRM overlay spinner must never cover them while a poll is in flight.
    isTvDisplayRoute() {
      return TV_DISPLAY_ROUTE_NAMES.includes(this.$route?.name);
    }
  },
  created: function() {
    // console.log('ones:', this.$store.state.commonState.loaderData.loader);
    this.$store.watch(
      (state, getters) => {
        return [state.commonState.loaderData.loader, getters.getLoaderStatus]
      },
      watched => {
        this.showLoader = this.$store.getters.getLoaderStatus;
      }
    )
  }
}

</script>

<style lang="scss">
  // CoreUI Icons Set
//   @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
//   $fa-font-path: '~font-awesome/fonts/';
//   @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
//   $simple-line-font-path: '~simple-line-icons/fonts/';
//   @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  // @import '~flag-icon-css/css/flag-icon.min.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
  @import 'assets/css/common.css';
  @import '@coreui/coreui/dist/css/coreui.min.css';
  // Vue Awesome notifications
  // @import 'vue-awesome-notifications/dist/styles/style.css';
  // Vue Select
  // @import "vue-select/src/scss/vue-select.scss";

//   @import url('https://fonts.googleapis.com/css2?family=Inter:wght@200;400;600&display=swap');


</style>
